import { render, staticRenderFns } from "./BriocheBackgroundImage.vue?vue&type=template&id=38ae8f0d&scoped=true&"
import script from "./BriocheBackgroundImage.vue?vue&type=script&lang=ts&"
export * from "./BriocheBackgroundImage.vue?vue&type=script&lang=ts&"
import style0 from "./BriocheBackgroundImage.vue?vue&type=style&index=0&id=38ae8f0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ae8f0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('38ae8f0d', component.options)
    } else {
      api.reload('38ae8f0d', component.options)
    }
    module.hot.accept("./BriocheBackgroundImage.vue?vue&type=template&id=38ae8f0d&scoped=true&", function () {
      api.rerender('38ae8f0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/BriocheBackgroundImage.vue"
export default component.exports